export default status => {
    const state = Number(status);
    let result;
    switch (status) {
        case 1:
            result = '全日制';
            break;
        case 2:
            result = '自考';

            break;
        case 3:
            result = '函授';
            break;
        case 4:
            result = '其他';
            break;
        default:
            break;
    }
    return result;
};
